"use client";
import { useCompositeGroupLabel } from "../composite/composite-group-label.js";
import { createElement, createHook, forwardRef } from "@ariakit/react-utils";
//#region src/menu/menu-group-label.tsx
const TagName = "div";
/**
* Returns props to create a `MenuGroupLabel` component. This hook must be used
* in a component that's wrapped with `MenuGroup` so the `aria-labelledby` prop
* is properly set on the menu group element.
* @see https://ariakit.com/components/menu
* @example
* ```jsx
* // This component must be wrapped with MenuGroup
* const props = useMenuGroupLabel();
* <Role {...props}>Label</Role>
* ```
*/
const useMenuGroupLabel = createHook(function useMenuGroupLabel(props) {
	props = useCompositeGroupLabel(props);
	return props;
});
/**
* Renders a label in a menu group. This component should be wrapped with
* [`MenuGroup`](https://ariakit.com/reference/menu-group) so the
* `aria-labelledby` is correctly set on the group element.
* @see https://ariakit.com/components/menu
* @example
* ```jsx {5}
* <MenuProvider>
*   <MenuButton>Recent Items</MenuButton>
*   <Menu>
*     <MenuGroup>
*       <MenuGroupLabel>Applications</MenuGroupLabel>
*       <MenuItem>Google Chrome.app</MenuItem>
*       <MenuItem>Safari.app</MenuItem>
*     </MenuGroup>
*   </Menu>
* </MenuProvider>
* ```
*/
const MenuGroupLabel = forwardRef(function MenuGroupLabel(props) {
	return createElement(TagName, useMenuGroupLabel(props));
});
//#endregion
export { MenuGroupLabel, useMenuGroupLabel };

//# sourceMappingURL=menu-group-label.js.map